import { render, staticRenderFns } from "./ResponseQueryBox.vue?vue&type=template&id=710f0ff8&scoped=true&"
import script from "./ResponseQueryBox.vue?vue&type=script&lang=js&"
export * from "./ResponseQueryBox.vue?vue&type=script&lang=js&"
import style0 from "./ResponseQueryBox.vue?vue&type=style&index=0&id=710f0ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f0ff8",
  null
  
)

export default component.exports